import { GridRowId } from "@mui/x-data-grid-pro";

export function codDownloadParams(search: string, assetIds: GridRowId[], selectAll: boolean) {
  const current = new URLSearchParams(search);
  const params = new URLSearchParams();

  if (selectAll) {
    params.set("select_all_flag", "true");
    const query = current.get("q");
    if (query) params.set("q", query);
    current.getAll("filter[]").forEach((filter) => params.append("filter[]", filter));
    const operator = current.get("filter_link_operator");
    if (operator) params.set("filter_link_operator", operator);
    return params;
  }

  assetIds.forEach((id) => params.append("asset_ids[]", String(id)));
  return params;
}

export function filenameFromContentDisposition(header?: string) {
  const match = /filename="([^"]+)"/.exec(header || "");
  return match?.[1] || "certificates-of-destruction.zip";
}

export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
}
